import { useMutation, useQuery } from 'react-query';

import { GetFoldersResponse, ResponseData, PaginationParams, OrderBy } from '@/features/folders/types';
import { axios } from '@/lib/axios';

type Params = {
  pagination: PaginationParams;
  order: OrderBy;
};

type Options = {
  isEnabled: boolean;
  onSuccess?: (data: ResponseData) => void;
};

const getFoldersAsync = ({ pagination, order }: Params) =>
  axios.get<GetFoldersResponse>(
    `/folders?$skip=${pagination.page}&$top=${pagination.pageSize}&$count=true&orderBy=${order.by} ${order.type}`,
  );

export const useGetFoldersAsync = (params: Params, { isEnabled, onSuccess }: Options = { isEnabled: true }) =>
  useQuery({
    cacheTime: 0,
    enabled: isEnabled,
    queryKey: ['folders', { ...params.pagination, ...params.order }],
    queryFn: async () => {
      const { data } = await getFoldersAsync(params);
      return {
        folders: data?.value ?? [],
        foldersCount: data?.['@odata.count'],
      };
    },
    onSuccess,
  });

export const useMutateGetFoldersAsync = () =>
  useMutation({
    mutationFn: getFoldersAsync,
  });
